export default "__VITE_ASSET__PxIEm9_8__"